/* Houroffer B2B tracking helpers for GTM/GA4. */
(function () {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  var GA4_MEASUREMENT_ID = 'G-VSNPNMTP4E';

  var ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'li_fat_id'
  ];

  function storageGet(name) {
    try {
      return window.localStorage.getItem(name);
    } catch (error) {
      return '';
    }
  }

  function storageSet(name, value) {
    try {
      window.localStorage.setItem(name, value);
    } catch (error) {
      return false;
    }
    return true;
  }

  function pageData() {
    return {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title || ''
    };
  }

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function pushEvent(name, params) {
    var payload = Object.assign({
      event: name
    }, pageData(), params || {});
    var ga4Payload = Object.assign({
      send_to: GA4_MEASUREMENT_ID
    }, pageData(), params || {});

    window.dataLayer.push(payload);
    window.gtag('event', name, ga4Payload);
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var attribution = {};

    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        attribution[key] = value;
        storageSet('houroffer_' + key, value);
      } else {
        attribution[key] = storageGet('houroffer_' + key) || '';
      }
    });

    if (!storageGet('houroffer_landing_page')) {
      storageSet('houroffer_landing_page', window.location.href);
    }

    if (document.referrer && !storageGet('houroffer_first_referrer')) {
      storageSet('houroffer_first_referrer', document.referrer);
    }

    attribution.landing_page = storageGet('houroffer_landing_page') || window.location.href;
    attribution.first_referrer = storageGet('houroffer_first_referrer') || document.referrer || '';

    return attribution;
  }

  function fieldNameFor(key) {
    return 'contact[' + key.replace(/_/g, ' ').replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    }) + ']';
  }

  function addHiddenField(form, name, value) {
    if (!form || !name || !value) return;
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var field = form.querySelector(selector);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function enrichForms() {
    var attribution = captureAttribution();
    var forms = document.querySelectorAll('form');

    forms.forEach(function (form) {
      if (!form.querySelector('[name^="contact["]')) return;

      Object.keys(attribution).forEach(function (key) {
        addHiddenField(form, fieldNameFor(key), attribution[key]);
      });

      addHiddenField(form, 'contact[Current Page]', window.location.href);
      addHiddenField(form, 'contact[Page Path]', window.location.pathname);
    });
  }

  function classifyContactLink(url) {
    if (!url) return '';
    if (url.indexOf('mailto:') === 0) return 'email';
    if (url.indexOf('tel:') === 0) return 'phone';
    if (url.indexOf('wa.me') !== -1 || url.indexOf('whatsapp') !== -1) return 'whatsapp';
    return '';
  }

  function isQuoteCta(target, href, text) {
    var normalized = cleanText(text).toLowerCase();
    var quoteText = /(get|request|send|contact|start).*(quote|inquiry|project)|oem inquiry|factory quote|request quote|contact factory team|start oem project|send your design/.test(normalized);
    var catalogText = /(download|get|view).*(catalog)|catalog request/.test(normalized);
    var quoteHref = href.indexOf('/pages/contact') !== -1 || href.indexOf('/pages/oem-odm') !== -1 || href.indexOf('#CatalogRequest') !== -1 || href.indexOf('#oem-rfq') !== -1 || href.indexOf('#B2BInquiryForm') !== -1;
    var catalogHref = href.indexOf('/pages/catalog') !== -1;
    var submitButton = target && target.tagName === 'BUTTON' && (target.type || '').toLowerCase() === 'submit';

    return quoteText || catalogText || quoteHref || catalogHref || submitButton;
  }

  function handleClick(event) {
    var target = event.target.closest ? event.target.closest('a, button') : null;
    if (!target) return;

    var href = target.href || target.getAttribute('href') || '';
    var text = cleanText(target.innerText || target.textContent || target.getAttribute('aria-label') || '');
    var contactMethod = classifyContactLink(href);

    if (contactMethod === 'email') {
      pushEvent('email_click', {
        link_url: href,
        link_text: text,
        contact_method: contactMethod
      });
      return;
    }

    if (contactMethod) {
      pushEvent('contact_click', {
        link_url: href,
        link_text: text,
        contact_method: contactMethod
      });
      return;
    }

    if (/\.pdf(\?|#|$)/i.test(href) || (/catalog/i.test(href) && /\.pdf/i.test(href))) {
      pushEvent('catalog_download', {
        link_url: href,
        link_text: text,
        download_type: 'pdf'
      });
      return;
    }

    if (isQuoteCta(target, href, text)) {
      pushEvent('quote_cta_click', {
        link_url: href,
        link_text: text,
        cta_type: href.indexOf('/pages/catalog') !== -1 || href.indexOf('#CatalogRequest') !== -1 ? 'catalog' : 'quote'
      });
    }
  }

  function hasContactSuccess() {
    return Boolean(
      document.querySelector('.houroffer-contact-rfq__success') ||
      document.querySelector('.oem-rfq-hero__success') ||
      document.querySelector('.b2b-inquiry__success') ||
      document.querySelector('[id^="Contact-success--"]')
    );
  }

  function hasCatalogSuccess() {
    return Boolean(
      document.querySelector('#CatalogRequestForm strong') ||
      document.querySelector('.catalog-form strong')
    );
  }

  function detectSuccessfulLead() {
    var params = new URLSearchParams(window.location.search);
    var hasShopifySuccess = params.get('contact_posted') === 'true';
    var path = window.location.pathname;
    var hash = window.location.hash || '';
    var isOemHeroForm = hash.indexOf('OEMHeroQuoteForm') !== -1;
    var eventName = '';
    var leadType = '';

    if (path === '/pages/catalog' && (hasShopifySuccess || hasCatalogSuccess())) {
      eventName = 'catalog_download';
      leadType = 'catalog_request';
    } else if (isOemHeroForm && hasShopifySuccess) {
      eventName = 'generate_lead';
      leadType = 'oem_inquiry';
    } else if ((path === '/pages/contact' || path === '/pages/oem-odm' || path === '/contact') && (hasShopifySuccess || hasContactSuccess())) {
      eventName = 'generate_lead';
      leadType = path === '/pages/oem-odm' || isOemHeroForm ? 'oem_inquiry' : 'factory_quote';
    } else if (hasContactSuccess()) {
      eventName = 'generate_lead';
      leadType = 'b2b_inquiry';
    }

    if (!eventName) return;

    var dedupeKey = 'houroffer_' + eventName + '_' + path + '_' + window.location.search + '_' + window.location.hash;
    if (storageGet(dedupeKey)) return;
    storageSet(dedupeKey, String(Date.now()));

    pushEvent(eventName, {
      lead_type: leadType
    });
  }

  function init() {
    captureAttribution();
    enrichForms();
    detectSuccessfulLead();
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
